import { render, staticRenderFns } from "./TransactionStatus.vue?vue&type=template&id=728d53bf&scoped=true&"
import script from "./TransactionStatus.vue?vue&type=script&lang=js&"
export * from "./TransactionStatus.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStatus.vue?vue&type=style&index=0&id=728d53bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d53bf",
  null
  
)

export default component.exports